export default __webpack_public_path__ + "static/media/biofit-builder-series-GG.76182c65.png";